import moment from "moment";
//const MillisecondsOffset = 11 * 60 * 60 * 1000; //NOTE GMT + 11 hours, not UTC + 10hours

export const ChartHelper = {
  formatDateTime(dtRaw) {
    return moment.utc(dtRaw, "YYYY-MM-DD HH:mm:ss").valueOf(); //return datetime as required by highcharts
  }
};
